import { apiNames, get, post, httpDelete } from '@general/api/shared';

export const fetchStripeCustomer = ({ locale = 'US', memberId }) =>
    get(apiNames.TRANSACTION, `billing/${memberId}/customer?${`locale=${locale}`}`);

export const createStripeIntent = memberId =>
    post({ apiName: apiNames.TRANSACTION, endpoint: `billing/${memberId}/payment-methods`, overrideHeaders: true });

export const deletePaymentMethod = paymentMethodId =>
    httpDelete({ apiName: apiNames.TRANSACTION, endpoint: `billing/payment-methods/${paymentMethodId}` });

export const setPaymentMethodAsDefault = (memberId, paymentMethodId) => {
    post({ apiName: apiNames.TRANSACTION, endpoint: `billing/${memberId}/payment-methods/${paymentMethodId}/default` });
};

export const savePaymentMethod = () => {
    return post({ apiName: apiNames.TRANSACTION, endpoint: `billing/save-payment-method` });
};

export const unsavePaymentMethod = () => {
    return post({ apiName: apiNames.TRANSACTION, endpoint: `billing/unsave-payment-method` });
};
